import script from "./Level4Params.vue?vue&type=script&setup=true&lang=js"
export * from "./Level4Params.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__